export class ReservationIdError extends Error {}
